<template>
  <div>
    <div v-if="isEnabled == 0"
         class="enableCard">
      <div class="d-flex flex-column enableCardInner">
        <div class="title">{{ $t('gateways.loadBalancerRecordPassive') }}</div>
        <div class="detail">{{ $t('gateways.enableLoadBalancerInfo') }}</div>
        <div class="mx-auto">
          <button class="btn btn-primary d-block px-12 py-3 rounded"
                  ref="enable_button"
                  @click="enableService">
            {{ $t('gateways.activate') }}
          </button>
        </div>
      </div>
    </div>

    <div v-else>
      <!-- List Table -->
      <List :header="header"
            :data="data"
            :pagination="pagination"
            :loading="loading"
            @updatePage="updatePage"
            :selectedItemId="selectedItemId">
        <!-- <template v-slot:item.nodes="{ item }">
          <div v-if="item.nodes">
            <div v-for="(node, index) in item.nodes.split(',')" :key="index">
              {{ node }}
            </div>
          </div>
        </template> -->

        <template v-slot:item.action="{ item }">
          <ActionButton icon="fas fa-pencil"
                        :title="$t('global.update')"
                        @click.native="openDetail(item)"></ActionButton>

          <DeleteButton icon="fad fa-trash"
                        :title="$t('global.delete')"
                        @click.native="openDeleteHandler(item)"></DeleteButton>

        </template>

        <template v-slot:subRow="{ item, selectedItemId }">
          <div v-if="selectedItemId == item.id"
               class="subRow d-flex align-items-top justify-content-between">
            <div>
              <b-form-group :label="$t('gateways.nodes')"
                            class="mb-0">
              </b-form-group>

              <div v-for="(pl,index) in item.nodeList"
                   :key="index">
                <div class="row mb-3">
                  <div class="col-10">
                    <b-form-input :id="`${index}-pKey`"
                                  v-model="item.nodeList[index]"
                                  :placeholder="$t('gateways.enterNode')"></b-form-input>
                  </div>
                  <div class="col-2">
                    <b-dropdown variant="success"
                                class="btn-icon more-dropdown"
                                right>
                      <template v-slot:button-content><i class="fas fa-cog p-0"></i></i>
                      </template>
                      <b-dropdown-item @click="addNewNodeItem(item.id)">{{$t('global.addNew')}}</b-dropdown-item>
                      <b-dropdown-divider />
                      <b-dropdown-item @click="removeNodeItem(item.id, index)"
                                       class="text-danger">{{$t('global.delete')}}</b-dropdown-item>
                    </b-dropdown>
                  </div>
                </div>
              </div>
            </div>

            <!-- buttons -->
            <div class="d-flex align-items-end flex-column">
              <div>
                <DeleteButton icon="far fa-times-circle"
                              :title="$t('global.close')"
                              @click.native="closeDetail()"></DeleteButton>
              </div>
              <div class="mt-auto pb-3">
                <b-button type="button"
                          variant="primary"
                          @click="saveDetail(item)"
                          class="px-10 mt-5">{{ $t('global.save') }}</b-button>
              </div>
            </div>
            <!-- /buttons -->
          </div>
        </template>
      </List>

      <b-button type="button"
                variant="primary"
                @click="createHostRecord"
                class="px-10 mt-5">{{ $t('gateways.createLoadBalanceHostRecord') }}</b-button>
    </div>

    <!-- Create Popup -->
    <DetailModal :title="$t('gateways.createLoadBalanceHostRecord')"
                 :show="showDetail"
                 @confirm="confirmModal()"
                 @closeDetail="closeHostRecord()"
                 :resetForm="resetForm">
      <GatewayLoadbalanceCreate :confirmModal="confirmCreate"
                                :gatewayId="gatewayId"
                                @resetDetailForm="resetHostRecordForm" />
    </DetailModal>

    <DeleteOperation :url="deleteOperationUrl"
                     @updateList="getList" />
  </div>
</template>

<script> 
// Services
import ApiService from '@/core/services/api.service'
import EventBus from '@/event-bus' 

export default {
  name: 'LoadBalancer',
  data() {
    return {
      loading: false,
      showDetail: false,
      confirmCreate: false,
      resetForm: false,
      header: [
        // { text: 'gateways.nodes', value: 'nodes' },
        { text: 'gateways.domainName', value: 'domain_name' },
        {
          text: 'gateways.balancingMethod',
          value: 'balancing_method',
        },
        { text: 'global.actions', value: 'action', size: '100px' },
      ],
      data: [],
      pagination: {},
      meta: {},
      selectedItemId: '',
      deleteOperationUrl: '',
    }
  },
  props: {
    gatewayId: {
      type: String,
      default: '',
    },
    isEnabled: {
      type: Number,
      default: 1,
    },
  },
  created() {
    this.getList()
  },
  methods: {
    getList() {
      if (this.isEnabled == 1) {
        this.loading = true

        let $query = `packetbender/netgateways/${this.gatewayId}/load-balancer`

        ApiService.get($query)
          .then(({ data }) => {
            if (data) {
              for (var i = 0; i < data.length; i++) {
                data[i].nodeList = data[i].nodes ? data[i].nodes.split(',') : []
              }
            }
            this.data = data
            this.loading = false
          })
          .catch((err) => {
            this.data = []
            this.loading = false
          })
      }
    },
    updatePage(value) {
      this.meta = value

      window.scrollTo({
        top: 0,
        behavior: 'smooth',
      })
    },
    enableService() {
      this.enableButton = this.$refs['enable_button']
      this.$spinnerLoader.addSpinnerLoader(this.enableButton)

      ApiService.post(
        `packetbender/netgateways/${this.gatewayId}/load-balancer`
      )
        .then(({ data }) => {
          EventBus.$emit('reloadGatewayDetail')
        })
        .catch((err) => {
          this.$spinnerLoader.removeSpinnerLoader(this.enableButton)
        })
    },
    createHostRecord() {
      this.closeDetail()
      this.showDetail = true
    },
    closeHostRecord() {
      this.showDetail = false
    },
    confirmModal() {
      this.confirmCreate = true
      setTimeout(() => {
        this.confirmCreate = false
      }, 200)
    },
    resetHostRecordForm(closeDetail = false) {
      if (closeDetail) {
        this.closeHostRecord()
        this.getList()
      }

      this.resetForm = true
      setTimeout(() => {
        this.resetForm = false
      }, 200)
    },
    openDetail(item) {
      this.selectedItemId = item.id
    },
    closeDetail() {
      this.selectedItemId = ''
    },
    addNewNodeItem(itemId) {
      let objIndex = this.data.findIndex((obj) => obj.id == itemId)
      this.data[objIndex].nodeList.push('')
    },
    removeNodeItem(itemId, index) {
      let objIndex = this.data.findIndex((obj) => obj.id == itemId)
      this.data[objIndex].nodeList.splice(index, 1)

      if (this.data[objIndex].nodeList.length == 0) this.addNewNodeItem(itemId)
    },
    saveDetail(item) {
      let params = {
        nodes: item.nodeList.join(','),
      }

      ApiService.put(
        `packetbender/netgateways/${this.gatewayId}/load-balancer/host/${item.id}`,
        params
      )
        .then(({ data }) => {
          this.$generateToast(this, 'success', this.$t('global.successful'))
        })
        .catch((err) => {
          this.$generateToast(this, 'danger', err.message, true)
        })
    },
    openDeleteHandler(item) {
      this.deleteOperationUrl = `packetbender/netgateways/${this.gatewayId}/load-balancer/host/${item.id}`
      this.$bvModal.show('modal-deleteOperation')
    },
  },
  watch: {
    meta: {
      handler() {
        this.getList()
      },
      deep: true,
    },
  },
  components: { 
    GatewayLoadbalanceCreate:()=>import('@/components/forms/GatewayLoadbalanceCreate')
  },
}
</script>
